module.exports = __webpack_public_path__ + "components/flag/static/square/kh-90cf7fc0863ff0d503f1df8debe2bdab.svg";